import React from "react";
import ReactDOM from "react-dom";

import "./index.css";
import "react-quill/dist/quill.snow.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "bootstrap-css-only/css/bootstrap.min.css";
import "mdbreact/dist/css/mdb.css";
import "font-awesome/css/font-awesome.css";
import "./component/ui/theme.css";

import App from "./App";
import './i18n'
import * as serviceWorker from "./serviceWorker";
import { overrideConsole } from "./utils/overrideConsole";
console.log("network mode", process.env.NODE_ENV);
// if (process.env.NODE_ENV === "development") {
//   const { worker } = require("./mocks/browser");
//   worker.start();
// }
/*
if(process.env.NODE_ENV === "production" && !localStorage.getItem("ENABLE_LOGS") === "true") {
  overrideConsole();
}*/

if (
  process.env.NODE_ENV === "production" &&
  localStorage.getItem("ENABLE_LOGS") !== "true"
) {
  overrideConsole();
}

ReactDOM.render(
  <React.Fragment>
    <App />
  </React.Fragment>,
  document.getElementById("root")
);
if (module.hot) {
  module.hot.accept();
}
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();
